import { config_lineChartEV, config_lineChartInt } from "../models/diagramsConfig";

const diagramsInit = (parties, type) => {
  if (type === "intention") {
    config_lineChartInt.xAxis.categories = [];
    config_lineChartInt.series =[];
    parties.forEach((party) => {
      party.data.intention.MAAvg = 0;
      party.data.intention.MASum = 0;
      party.data.intention.MAIndex = 0;
      party.data.intention.percentages = [];
    });
  }

  if (type === "evaluation") {
    config_lineChartEV.xAxis.categories = [];
    config_lineChartEV.series =[];
    parties.forEach((party) => {
      party.data.evaluation.trend = 0;
      party.data.evaluation.MAAvg = 0;
      party.data.evaluation.MASum = 0;
      party.data.evaluation.MAIndex = 0;
      party.data.evaluation.percentages = [];

    });
  }
};
export default diagramsInit;
